/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Scissors = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M2.60836 2.88084C3.77902 1.00739 6.24677 0.437663 8.12023 1.60833C9.99368 2.77899 10.5634 5.24674 9.39274 7.1202L9.27547 7.29742C8.77026 8.01905 8.06391 8.52623 7.28057 8.79031L10.8891 11.1027L20.6006 4.84971L21.4127 6.11086L12.2771 11.9927L21.4114 17.8489L20.6019 19.1117L10.8911 12.8857L7.27157 15.215C8.0585 15.4782 8.76833 15.9865 9.27547 16.7109L9.39274 16.8881C10.5634 18.7616 9.99368 21.2293 8.12023 22.4C6.24677 23.5707 3.77902 23.0009 2.60836 21.1275C1.45967 19.2892 1.98664 16.8787 3.77675 15.6829L9.50314 11.9957L3.77841 8.32635C1.98703 7.1314 1.45924 4.71981 2.60836 2.88084ZM4.68565 16.8815L4.53365 16.9833C3.47706 17.7472 3.17925 19.2105 3.88043 20.3326C4.6121 21.5035 6.15444 21.8596 7.32535 21.1279C8.49626 20.3963 8.85234 18.8539 8.12067 17.683C7.39107 16.5154 5.85534 16.158 4.68565 16.8815ZM7.32535 2.8804C6.15444 2.14873 4.6121 2.50481 3.88043 3.67572C3.17925 4.79784 3.47706 6.26109 4.53365 7.02505L4.68565 7.12679C5.80647 7.82006 7.26337 7.52091 8.02508 6.46742L8.12067 6.32532C8.85234 5.15441 8.49626 3.61207 7.32535 2.8804Z"
                        fill={color}
                    />
                </svg>
        );
    };
